import React from 'react';
import PropTypes from 'prop-types';

export default class CustomersQuickLink extends React.Component<any> {

    static propTypes = {
        project: PropTypes.object,
    }

    onClick = () => {
        gd.goTo('p/{0}/info/customers'.f(this.props.project.id));
    }

    render() {
        if (this.props.project.isTemplate)                                                  return false;
        if (!gd.ac.check.project.standardAccess(this.props.project.id, this.props.project)) return false;
        if (this.props.project.systemType === gd.const.project.type.TAG)                    return false;


        const projectClients = gd.session.projectUsers.clients(this.props.project.id)
        const customersCount = projectClients.length

        // do not show anything if no customers found
        if (!customersCount) return false;

        return (
            <div className="ui5-sharing m-r-8" onClick={this.onClick}>
                <div className="sharing-icon i5-crm-account"/>
                <span className="total">{customersCount}</span>
            </div>
        )
    }
}